module.exports = __webpack_public_path__ + "img/activefixresume.22e2c00d.svg";